


(function ($, window, document) {
  'use strict';

  if (!$) return;

  window.Shopify = window.Shopify || {};
  if (!window.Shopify.money_format) {
    window.Shopify.money_format = '${{amount}}';
  }

  window.Shopify.formatMoney = function (cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';

      return dollars + centsPart;
    }

    var placeholder = formatString.match(placeholderRegex);
    if (!placeholder) return formatString;

    switch (placeholder[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  };

  var $win = $(window);
  var $doc = $(document);
  var $body = $('body');

  function debounce(fn, wait) {
    var timer;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function throttle(fn, wait) {
    var last = 0;
    var timer;

    return function () {
      var now = Date.now();
      var remaining = wait - (now - last);
      var context = this;
      var args = arguments;

      if (remaining <= 0) {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
        last = now;
        fn.apply(context, args);
        return;
      }

      if (!timer) {
        timer = setTimeout(function () {
          last = Date.now();
          timer = null;
          fn.apply(context, args);
        }, remaining);
      }
    };
  }

  function markLoadedImages() {
    $('.loading-image').removeClass('loading-image').addClass('loaded-image');
  }

  function initPreloader() {
    if (!$('#preloader').length) return;

    $win.one('load.themePreloader', function () {
      $('#preloader').delay(1000).fadeOut(1000, function () {
        if ($('.preloader-overflow').length) {
          $body.removeClass('preloader-overflow');
        }
      });
    });
  }

  function initMediaSliders() {
    var $lists = $('.media-slick-slider .thumbnail-list');
    if (!$lists.length || !$.fn.slick) return;

    var isDesktop = $win.width() > 1024;

    $lists.each(function () {
      var $list = $(this);
      var itemCount = $list.find('li').length;

      if (isDesktop) {
        if (itemCount > 6 && !$list.hasClass('slick-initialized')) {
          $list.slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            vertical: true,
            focusOnSelect: true,
            verticalSwiping: true,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  vertical: false
                }
              },
              {
                breakpoint: 1541,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              }
            ]
          });
        }
      } else if ($list.hasClass('slick-initialized')) {
        $list.slick('unslick');
      }
    });
  }

  var handleStickyBar = throttle(function () {
    var scrollTop = $win.scrollTop();
    var isDesktop = $win.width() > 1024;
    var shouldBeActive = isDesktop ? scrollTop >= 700 : scrollTop >= 900;

    $('.sticky-bar').toggleClass('active', shouldBeActive);
  }, 100);

  function initStickyBar() {
    $win.off('scroll.themeSticky resize.themeSticky orientationchange.themeSticky');
    $win.on('scroll.themeSticky resize.themeSticky orientationchange.themeSticky', handleStickyBar);
    handleStickyBar();
  }

  function initRecentlyViewedToggle() {
    $doc.off('click.themeRecently').on('click.themeRecently', '#recently', function (e) {
      e.preventDefault();
      $('#recently-viewed-products').stop(true, true).slideToggle(500);
    });
  }

  function initLoadMore() {
    var afterInfiniteLoaded = function () {
      markLoadedImages();
    };

    var ajaxMethod = $('.pagination-method-loadmore_btn').length > 0 ? 'click' : 'scroll';

    if ($('.collection #AjaxinatePagination').length > 0 && typeof window.Ajaxinate !== 'undefined') {
      window.endlessScroll = new Ajaxinate({
        container: '.AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        method: ajaxMethod,
        offset: 0,
        callback: afterInfiniteLoaded
      });
    }
  }

  function updateFacetActiveState() {
    $('.facet-checkbox input:checkbox').each(function () {
      $(this).parent('.facet-checkbox').toggleClass('active', $(this).is(':checked'));
    });
  }

  function initFilterControls() {
    $doc.off('click.themeFilters').on('click.themeFilters', '.toggleFilter', function (e) {
      e.preventDefault();

      var $filter = $(this);
      var $sidebar = $('.facets-vertical');
      var $closeDiv = $('.close-sidebar');

      if (!$sidebar.length) return;

      $filter.toggleClass('active');
      $sidebar.toggleClass('open');
      $body.addClass('overflow-hidden filter-clicked');

      if ($closeDiv.length) {
        $closeDiv.off('click.themeFiltersClose').on('click.themeFiltersClose', function () {
          $filter.removeClass('active');
          $sidebar.removeClass('open');
          $body.removeClass('overflow-hidden filter-clicked');
        });
      }
    });

    $doc.off('click.themeGridView').on('click.themeGridView', '.custom-product-grid li', function () {
      var classNames = 'list-view-filter grid--2-col-desktop grid--3-col-desktop grid--4-col-desktop grid--5-col-desktop grid--6-col-desktop align-1-column align-2-column align-3-column align-4-column align-5-column';
      var getCols = $(this).data('cols');
      var getVal = 'align-' + $(this).data('val') + '-column';

      $('.custom-product-grid li').removeClass('active');
      $(this).addClass('active');
      $('ul#product-grid').removeClass(classNames).addClass(getCols + ' ' + getVal);
    });

    $doc.off('click.themeViewMode').on('click.themeViewMode', '.list-view-button, .grid-view-button', function () {
      var $gridButton = $('.grid-view-button');
      var $listButton = $('.list-view-button');
      var $list = $('ul.view-mode');
      var $gridViewList = $('.custom-product-grid');

      if (!$gridButton.length || !$listButton.length || !$list.length || !$gridViewList.length) return;

      if ($(this).hasClass('list-view-button')) {
        $listButton.addClass('active');
        $gridButton.removeClass('active');
        $list.removeClass('grid-view-filter').addClass('list-view-filter');
        $gridViewList.addClass('hidden');
      } else {
        $listButton.removeClass('active');
        $gridButton.addClass('active');
        $list.removeClass('list-view-filter').addClass('grid-view-filter');
        $gridViewList.removeClass('hidden');
      }
    });
  }

  function initSidebarCarousel() {
    var $carousel = $('#swiper-sidebar-carousel');
    if (!$carousel.length || typeof window.Swiper === 'undefined') return;
    if ($carousel.data('swiper-initialized')) return;

    $carousel.data('swiper-initialized', true);

    new Swiper('#swiper-sidebar-carousel', {
      navigation: {
        nextEl: '#swiper-sidebar-next',
        prevEl: '#swiper-sidebar-prev'
      }
    });
  }

  function initLoadingImageCleanup() {
    if (!$('.loading-image').length) return;

    if (document.readyState === 'complete') {
      setTimeout(markLoadedImages, 2000);
    } else {
      $win.one('load.themeLoadedImages', function () {
        setTimeout(markLoadedImages, 2000);
      });
    }
  }

  function initSortSummary() {
    var $radioButtons = $('.dt-sort__container input[name="sort_by"]');
    var $optionSummary = $('.dt-sort__container .facets__summary-label');
    if (!$radioButtons.length || !$optionSummary.length) return;

    $radioButtons.each(function () {
      if (this.checked) {
        $optionSummary.html($(this).attr('data-value') || $(this).val());
      }
    });

    $doc.off('change.themeSort').on('change.themeSort', '.dt-sort__container input[name="sort_by"]', function () {
      var value = $(this).attr('data-value') || $(this).val();
      $optionSummary.html(value);
    });
  }

  function initSearchToggles() {
    $doc.off('click.themeStickySearch').on('click.themeStickySearch', '#dT_TopStickySearchBtn', function (ev) {
      ev.preventDefault();
      $('#dT_top-sticky').addClass('search-show');
      $('#dT_top-sticky .search-modal').css('opacity', '1');
      $body.addClass('search-overlay-open');
    });

    $doc.off('click.themeStickySearchClose').on('click.themeStickySearchClose', '.dT_TopStickySearchCloseBtn', function (ev) {
      ev.preventDefault();
      $('#dT_top-sticky').removeClass('search-show');
      $('#dT_top-sticky .search-modal').css('opacity', '0');
      $body.removeClass('search-overlay-open');
    });
  }

  function initHeaderDrawerClose() {
    var closeButton = document.querySelector('.header-drawer__close');
    if (!closeButton || closeButton.dataset.bound === 'true') return;

    closeButton.dataset.bound = 'true';
    closeButton.addEventListener('click', function () {
      document.body.classList.remove('overflow-hidden-tablet');
    });
  }

  function initTabsAndAccordion() {
    $doc.off('click.themeTabs').on('click.themeTabs', '.acc__title', function (e) {
      var $title = $(this);
      var $dropDown = $title.closest('.dt-sc-tabs-content');
      var $siblings = $title.closest('.dt-sc-tabs-content').siblings('.dt-sc-tabs-content');

      $siblings.not($dropDown).stop(false, true).slideUp();

      if ($title.hasClass('active')) {
        $title.removeClass('active');
      } else {
        $title.closest('.dt-sc-tabs-content.active').removeClass('active');
        $title.addClass('active');
      }

      $dropDown.stop(false, true).slideToggle();
      e.preventDefault();
    });

    $doc.off('click.themeTabLinks').on('click.themeTabLinks', '.tablinks', function () {
      var id = $(this).attr('data-id');
      $('.dt-sc-tabs-content').removeClass('tab-active-content');
      $(".dt-sc-tabs-content[data-id='" + id + "']").addClass('tab-active-content');
      $('.tablinks').removeClass('active-tab');
      $(this).addClass('active-tab');
    });
  }

  function closeHotspots() {
    $('.dt-sc-hotspot-wrapper').removeClass('this-hotspot-in-active');
    $('.dt-sc-hotspot-popup').removeClass('dt-sc-popup-open');
    $('.dt-sc-hotspot-item').removeClass('open');
    $('a.dt-sc-hotspot-marker').removeClass('clicked').css({
      opacity: '1',
      'pointer-events': 'auto'
    });
  }

  var hotspotMode = null;

  function initHotspots() {
    var width = $win.width();
    var nextMode = width < 251 ? 'mobile' : ($('.tool-tip-style-3').length ? 'hover' : ($('.tool-tip-style-1').length ? 'click' : 'none'));

    if (nextMode === hotspotMode) return;
    hotspotMode = nextMode;

    $doc.off('.themeHotspot');

    if (nextMode === 'mobile') {
      if ($.fn.magnificPopup) {
        $('.dt-sc-hotspot-popup').addClass('mfp-hide');
        $('.dt-sc-hotspot-marker').each(function () {
          var $marker = $(this);
          if ($marker.data('mfp-initialized')) return;
          $marker.data('mfp-initialized', true);
          $marker.magnificPopup({
            type: 'inline',
            closeOnBgClick: true,
            closeBtnInside: false,
            showCloseBtn: true
          });
        });
      }
      return;
    }

    if (nextMode === 'click') {
      $doc.on('click.themeHotspot', 'a.dt-sc-hotspot-marker', function (e) {
        if (!$(this).closest('.tool-tip-style-1').length) return;

        e.preventDefault();
        e.stopPropagation();

        var $marker = $(this);
        var $item = $marker.closest('.dt-sc-hotspot-item');
        var $popup = $item.find('.dt-sc-hotspot-popup');

        $item.addClass('this-hotspot-in-active');

        if ($marker.hasClass('clicked')) {
          $marker.removeClass('clicked');
          $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css({ opacity: '0', 'pointer-events': 'none' });
          $marker.css({ opacity: '1', 'pointer-events': 'none' });
          $('.dt-sc-hotspot-item').removeClass('open');
          $('a.dt-sc-hotspot-marker').css({ opacity: '1', 'pointer-events': 'none' });
        } else {
          $marker.addClass('clicked');
          $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css({ opacity: '0', 'pointer-events': 'none' });
          $marker.css({ opacity: '1', 'pointer-events': 'auto' });
          $item.addClass('open');
          $popup.toggleClass('dt-sc-popup-open');
          $item.siblings().children('.dt-sc-hotspot-popup').removeClass('dt-sc-popup-open');
        }
      });

      $doc.on('click.themeHotspot', function (e) {
        if ($(e.target).closest('.dt-sc-hotspot-item, .mfp-wrap, .mfp-bg').length) return;
        closeHotspots();
      });

      $doc.on('click.themeHotspot', '.tool-tip-style-1 .dt-sc-hotspot-popup', function (e) {
        e.stopPropagation();
      });

      return;
    }

    if (nextMode === 'hover') {
      $doc.on('mouseenter.themeHotspot', '.tool-tip-style-3 .dt-sc-hotspot-item', function () {
        var $item = $(this);
        var $marker = $item.find('a.dt-sc-hotspot-marker');
        var $popup = $item.find('.dt-sc-hotspot-popup');

        $item.addClass('this-hotspot-in-active');

        if ($marker.hasClass('clicked')) {
          $marker.removeClass('clicked');
          $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css({ opacity: '0', 'pointer-events': 'none' });
          $marker.css({ opacity: '1', 'pointer-events': 'auto' });
          $('.dt-sc-hotspot-item').removeClass('open');
          $('a.dt-sc-hotspot-marker').css({ opacity: '1', 'pointer-events': 'auto' });
        } else {
          $marker.addClass('clicked');
          $('.this-hotspot-in-active').find('a.dt-sc-hotspot-marker').css({ opacity: '0', 'pointer-events': 'none' });
          $marker.css({ opacity: '1', 'pointer-events': 'auto' });
          $item.addClass('open');
          $popup.toggleClass('dt-sc-popup-open');
          $item.siblings().children('.dt-sc-hotspot-popup').removeClass('dt-sc-popup-open');
        }
      });

      $doc.on('mouseleave.themeHotspot', '.tool-tip-style-3 .dt-sc-hotspot-item', function () {
        closeHotspots();
      });

      $doc.on('click.themeHotspot', function (e) {
        if ($(e.target).closest('.dt-sc-hotspot-item, .mfp-wrap, .mfp-bg').length) return;
        closeHotspots();
      });
    }
  }

  function initCardSwatches() {
    $doc.off('click.themeSwatch').on('click.themeSwatch', '.color-values a', function () {
      var $colorLinks = $(this).closest('.variant-option-color').find('.color-values a');
      $colorLinks.removeClass('active');
      $(this).addClass('active');
    });

    $doc.off('click.themeSizeSwatch').on('click.themeSizeSwatch', '.size-values a', function () {
      $('.size-values a').removeClass('active');
      $(this).addClass('active');
    });

    $doc.off('click.themeColorPlus').on('click.themeColorPlus', '.color-values-plus a', function () {
      $(this).parents('.variant-option-color').find('.show-on-click').css('display', 'flex');
      $(this).parents('.color-values-plus').css('display', 'none');
    });

    $doc.off('click.themeCardSwatch').on('click.themeCardSwatch', '.swatch span', function () {
      var $swatch = $(this);
      var $cardWrapper = $swatch.parents('.card-wrapper');
      var $motionReduce = $cardWrapper.find('.card__inner .motion-reduce');
      var imageUrl = $swatch.data('image');

      if ($motionReduce.length && imageUrl) {
        $motionReduce.attr('srcset', imageUrl);
      }

      if ($swatch.parents('.swatch').hasClass('color')) {
        var variant = $swatch.data('id');
        var swatchItem = $swatch.data('variant-item');

        $swatch.parents('.product-grid').find('.variant-push').val(variant);
        $swatch.parents('.product-grid').find('.variant-option-size .size-values').removeClass('active');

        $swatch.parents('.product-grid').find('.variant-option-size .swatch').each(function () {
          var variantTitle = $(this).find('span').data('variant-title');
          if (!variantTitle) return;

          var swatchSizeVars = variantTitle.split('/').map($.trim).map(function (n) {
            return n.toLowerCase().replace(/ /g, '-');
          });

          if ($.inArray(swatchItem, swatchSizeVars) >= 0) {
            $(this).parent('.size-values').toggleClass('active');
          }
        });
      }

      if ($swatch.parents('.swatch').hasClass('size')) {
        var sizeVariant = $swatch.data('id');
        $swatch.parents('.product-grid').find('.variant-push').val(sizeVariant);
      }
    });
  }

  function initCustomSelects() {
    $doc.off('click.themeCustomSelect').on('click.themeCustomSelect', 'ul.custom-select', function (e) {
      var $target = $(e.target);

      if ($target.is('li:not(.init)')) {
        var selectedVal = $target.data('option-value');
        var $meta = $target.parents('.fbt-product__meta');
        var $select = $meta.find('.selectVariant option');

        $select.attr('selected', false);
        $meta.find('.selectVariant option[value="' + selectedVal + '"]').attr('selected', 'selected').trigger('change');
      }

      if ($target.hasClass('init')) {
        $target.closest('ul.custom-select').children('li:not(.init)').toggle();
      }
    });

    $doc.off('click.themeCustomSelectItem').on('click.themeCustomSelectItem', 'ul.custom-select li:not(.init)', function () {
      var $item = $(this);
      $item.parent().children('li:not(.init)').removeClass('selected');
      $item.addClass('selected');
      $item.parent().children('.init').html($item.html()).removeClass('li-unselected');
      $item.parent().children('li:not(.init)').toggle();

      $('#add-frequently-bought').prop('disabled', $('ul.custom-select li.init').hasClass('li-unselected'));
    });
  }

  function initVideoReset() {
    $doc.off('click.themeVideoReset').on('click.themeVideoReset', function (e) {
      if ($(e.target).is('a, button, input, select, textarea, label')) return;

      $doc.find('iframe').each(function () {
        try {
          $(this).contents().find('video').each(function () {
            this.currentTime = 0;
            this.pause();
          });
        } catch (err) {
          // cross origin iframes ignored
        }
      });
    });
  }

  function initMiscUI() {
    setTimeout(function () {
      $('#AccessibleNav .sub-menu-block').show();
    }, 1000);

    $win.one('load.themeMainContent', function () {
      setTimeout(function () {
        var mainContent = document.getElementById('MainContent');
        if (mainContent) {
          mainContent.classList.remove('placeholder-shadow-blocks');
        }
      }, 2000);
    });

    if (document.readyState === 'complete') {
      setTimeout(markLoadedImages, 3000);
    } else {
      $win.one('load.themeLoadedBg', function () {
        setTimeout(markLoadedImages, 3000);
      });
    }
  }

  function initDealTimer() {
    var $deals = $('.product-deal-count');
    if (!$deals.length) return;

    function makeTimer() {
      $deals.each(function () {
        var $count = $(this);
        var endTime = new Date($count.attr('data-end-time'));
        endTime = Date.parse(endTime) / 1000;

        var now = Date.parse(new Date()) / 1000;
        var timeLeft = endTime - now;

        if (timeLeft > 0) {
          var days = Math.floor(timeLeft / 86400);
          var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
          var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600)) / 60);
          var seconds = Math.floor(timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60));

          if (hours < 10) hours = '0' + hours;
          if (minutes < 10) minutes = '0' + minutes;
          if (seconds < 10) seconds = '0' + seconds;

          $count.find('.days').html(days + '<span>' + (window.deals && window.deals.days ? window.deals.days : 'Days') + '</span>');
          $count.find('.hours').html(hours + '<span>' + (window.deals && window.deals.hours ? window.deals.hours : 'Hours') + '</span>');
          $count.find('.minutes').html(minutes + '<span>' + (window.deals && window.deals.minutes ? window.deals.minutes : 'Minutes') + '</span>');
          $count.find('.seconds').html(seconds + '<span>' + (window.deals && window.deals.seconds ? window.deals.seconds : 'Seconds') + '</span>');
        } else {
          $count.find('.deal-lable, .deal-clock').hide();
        }
      });
    }

    makeTimer();
    setInterval(makeTimer, 1000);
  }

  function initTopLevelHandlers() {
    initPreloader();
    initMediaSliders();
    initStickyBar();
    initRecentlyViewedToggle();
    initLoadMore();
    initFilterControls();
    initSidebarCarousel();
    initLoadingImageCleanup();
    initSortSummary();
    initSearchToggles();
    initHeaderDrawerClose();
    initTabsAndAccordion();
    initHotspots();
    initCardSwatches();
    initCustomSelects();
    initVideoReset();
    initMiscUI();
    initDealTimer();
    updateFacetActiveState();
  }

  $doc.ready(initTopLevelHandlers);

  $win.on('resize.themeCore orientationchange.themeCore', debounce(function () {
    initMediaSliders();
    initHotspots();
    handleStickyBar();
  }, 150));

})(window.jQuery || window.$, window, document);